export default __webpack_public_path__ + "static/media/agenda.dfe95f8a.png";